export const OrderStatusEnum = {
  ACTIVE: 'ACTIVE'
};
